import React from 'react';
import { RiDeleteBin4Fill } from 'react-icons/ri';
import { Note } from '../../../store/slices/teamFocusSession/types';

import EmptyState from '../../ui/empty-state';

interface NotesTabProps {
    notes?: Note[];
    onDeleteNote: (noteId: string) => void;
    onEditNote?: (note: Note) => void;
}

const NotesTab: React.FC<NotesTabProps> = ({
    notes = [],
    onDeleteNote,
    onEditNote,
}) => {
    // defensive: sometimes upstream might pass null/object; coerce to array
    const safeNotes: Note[] = Array.isArray(notes) ? notes : [];

    return (
        <div>
            <div className="space-y-3">
                {safeNotes.map(note => (
                    <div key={note.id} className="p-4 border rounded-xl hover:border-orange-200/60 flex justify-between group">
                        <div className="flex-1">
                            <p
                                className="text-gray-900 text-sm cursor-pointer"
                                onClick={() => onEditNote?.(note)}
                            >
                                {note.note}
                            </p>
                        </div>
                        <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button onClick={() => onDeleteNote(note.id)} className="text-gray-400 hover:text-red-500">
                                <RiDeleteBin4Fill />
                            </button>
                        </div>
                    </div>
                ))}
                {notes.length === 0 && (
                    <EmptyState
                        icon="📓"
                        title="No notes yet"
                        description="Use the button below to add your first note."
                    />
                )}
            </div>
        </div>
    );
};

export default NotesTab;
